import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}
export function CtaButton({
  href,
  children,
  className = ''
}: CtaButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center rounded-xl border-b-4 border-olive-dark bg-olive px-4 py-3.5 text-center text-sm font-extrabold uppercase tracking-wide text-crudo shadow-[0_0_0_3px_rgb(79_99_61/0.2)] transition-[background-color,transform] duration-150 ease-soft hover:bg-olive-dark active:translate-y-px active:scale-[0.99] sm:text-lg ${className}`} data-id="element-158" data-mp="1vvhde7s5cuuj">
      {children}
    </a>;
}